import React from 'react';
import { Image } from '@/components';
interface ConfettiProps {
  title: string;
  key: string;
  wrapperClass: string;
}
const Confetti = ({ title, wrapperClass, key }: ConfettiProps) => {
  return (
    <div className={wrapperClass}>
      <span className="tw-mr-2 tw-text-xs md:tw-text-13">{title}</span>
      {[1, 2, 3].map((n) => (
        <Image
          src="/confetti-flat.gif"
          className="tw-w-4 tw-h-4 md:tw-w-6 md:tw-h-6"
          alt="confetti"
          key={`${key}--${n}`}
        ></Image>
      ))}
    </div>
  );
};

export default Confetti;
